import React, { useState, useEffect } from 'react';
import { Segment } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import TrendTable from './Table';
import Visualis from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/RevenueDownload/TrendsCard/Visualis';
import { useIntl } from 'umi';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    lineData,
    cardStatus,
    trendComputeType,
    trendCountValue,
    dateType,
    columnsList,
    entityType,
    tabId,
    setChartLoading,
    chartLoading,
  } = props;

  // console.log('TrendsCard', props);

  const { formatMessage } = useIntl(); // 中英切换方法
  const { isLoading, isError, isNoData } = cardStatus || {};

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_trend` })}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <div className="dbi-trends-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context dbi-mobileGames-title-custom"
        title={formatMessage({ id: `dbi_detail_trend` })}
        subTitle={`${trendComputeType} Physical Revenue: ${trendCountValue}`}
        activeTab={'line'}
        disableChartType={['bar', 'pie']}
      >
        <div className="trends-card-line">
          <Visualis
            chartType={'line'}
            dateType={dateType}
            imageType={entityType}
            lineData={lineData}
            isNodata={isNoData}
            metric={tabId}
            chartLoading={chartLoading}
            setChartLoading={setChartLoading}
            topChartsType={'gamesOwned-revenueDownload-trend'}
            titleNow={'Physical Revenue'}
          />
        </div>
        <TrendTable
          entityType={entityType}
          tableData={tableData}
          dateType={dateType}
          // pageSortAttr={pageSortAttr}
          columnsList={columnsList}
        />
      </CardSlotV2>
    </div>
  );
};
export default TrendsCard;
